import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/_components/home-page.tsx");
